// extracted by mini-css-extract-plugin
module.exports = {"locl-base-layout":"base-layout_locl-base-layout__XghVf","locl-base-layout__content":"base-layout_locl-base-layout__content__ksX_b"};